import { MarketPeriods } from "app/utils/const";
import moment from "moment-timezone";
import { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { SessionHelper } from "../../../../helpers/sessionHelper";
type Props = {
  value: string;
  countDown?: boolean;
  eventPhase?: string;
  timezone: Record<string, any>;
};

class MomentTime extends Component<Props> {
  render() {
    const { value, countDown, eventPhase, timezone } = this.props;
    // Default formats for normal timestamp
    let format = "HH:mm";
    let filter;

    // if count down is activated
    if (countDown) {
      const prependZero = number =>
        number > 0 && number < 10 ? "0" + number : number;

      // use filter to check if we need to update time
      filter = d => {
        const differenceInMinutes = moment(value).diff(moment(), "m");

        // check if time is less than one hour but more than zero
        if (differenceInMinutes > 0 && differenceInMinutes < 60) {
          // format the number
          const countDownValue = `-${prependZero(differenceInMinutes)}’`;
          return <span className="countdown">{countDownValue}</span>;
        } else if (differenceInMinutes <= 0) {
          const minutes = parseInt(differenceInMinutes % 60, 10);
          // BET-3057 - Math.abs turns negative numbers into positive ones
          return eventPhase && eventPhase === MarketPeriods.SECOND_HALF
            ? prependZero(Math.abs(minutes - 45)) + "’"
            : prependZero(Math.abs(minutes)) + "’";
        }

        return d;
      };
    }

    return (
      <div>
        <Moment format={format} filter={filter}>
          {SessionHelper.isAsianRouteAndSessionView()
            ? moment(value).tz(timezone.name)
            : value}
        </Moment>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  timezone: state.userModel.timezone,
});

export default connect(mapStateToProps)(MomentTime) as any;
